import { supabase } from '@/integrations/supabase/client';
import { waitingQuotesByRequest } from '@/utils/waitingQuotes';

// Pending quotes per open request of this customer. Empty on any error: the badge is a hint, not a gate.
export const fetchWaitingQuotes = async (userId: string): Promise<Record<string, number>> => {
  try {
    const { data: requests, error: requestsError } = await supabase
      .from('requests')
      .select('id, status')
      .eq('user_id', userId)
      .eq('status', 'active');
    if (requestsError || !requests?.length) return {};

    const { data: quotes, error: quotesError } = await supabase
      .from('quotes')
      .select('request_id, status')
      .in('request_id', requests.map(r => r.id))
      .eq('status', 'pending');
    if (quotesError) return {};

    return waitingQuotesByRequest(requests, quotes ?? []);
  } catch (error) {
    console.error('Error fetching waiting quotes:', error);
    return {};
  }
};
